import { HStack, Icon, Separator, Text } from "@chakra-ui/react";
import { useThemeColors } from "../../hooks/useThemeColors";
import useIcons from "../../hooks/useIcons";

export default function InlineSeparator({ label }: { label: string }) {
  const colors = useThemeColors();
  const icons = useIcons();
  return (
    <HStack mb={3} color={colors.schoolAccent.secondary}>
      <Icon as={icons.utility.chevronRight} />
      <Text flexShrink="0">{label}</Text>
      <Separator borderColor={colors.schoolAccent.secondary} flex="1" />
    </HStack>
  );
}
